
export default {
  name: "ObserverHOC",
  props: {
    className: {
      type: String,
      required: true
    },
    triggerFunction: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      observers: []
    }
  },
  mounted() {
    this.createObservers()
  },
  beforeDestroy() {
    this.disconnectObservers()
  },
  methods: {
    createObservers() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.9
      }

      const elements = this.$el.querySelectorAll(this.className)
      elements.forEach(el => {
        const observer = new IntersectionObserver(this.handleIntersect, options)
        observer.observe(el)
        this.observers.push(observer)
      })
    },
    handleIntersect(entries) {
      const elements = [...this.$el.querySelectorAll(this.className)]

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = elements.indexOf(entry.target)
          this.triggerFunction(entry.target, index)
        }
      })
    },
    disconnectObservers() {
      this.observers.forEach(observer => observer.disconnect())
    }
  }
}
